import * as Yup from 'yup';

const required = 'validator.required';
const durationMustNotBeZeroText = 'validator.error.durationMustNotBeZeroText';
function durationMustNotBeZero() {
  return (
    this.parent.durationHours > 0 ||
    this.parent.durationMinutes > 0 ||
    this.parent.durationSeconds > 0
  );
}

export const CreateSpecialJobValuesSchema = Yup.object().shape({
  name: Yup.string().required(required),
  description: Yup.string().required(required),
  durationHours: Yup.number()
    .min(0, 'validator.error.notNegative')
    .required(required)
    .test('oneOfRequired', durationMustNotBeZeroText, durationMustNotBeZero),
  durationMinutes: Yup.number()
    .min(0, 'validator.error.notNegative')
    .required(required),
  durationSeconds: Yup.number()
    .min(0, 'validator.error.notNegative')
    .required(required),
  amount: Yup.number().min(1, 'validator.error.minOne').required(required),
  employeeId: Yup.string().required(required),
});
